module.exports = __webpack_public_path__ + "img/free.1eb959d4.svg";